/**
 * Métodos para módulos
 * @type {Object}
 */
MdHub.module = {
  build: '0',
  commands: {}, // Lista de comandos do módulo
  events: {}, // Lista de eventos do módulo
  list: {}, // Lista de módulos carregados - MdHub Server
  listCatchAll: {}, // Lista de nome de módulos em modo catchAll
  listShowing: {}, // Lista de nome de módulos que estão sendo mostrados
  name: '', // Nome do módulo - MdHub Client
  options: {}, // Opções do módulo - MdHub Client
  require: {}, // Dependências do módulo
  styesDefault: { // Estilos padrões para o iframe do módulo
    border: 'none',
    display: 'none',
    height: '100%',
    left: '0',
    overflow: 'auto',
    position: 'fixed',
    right: '0',
    width: '100%',
    // O máximo é 2147483647, deixar 10 a menos para outros módulos como o plataforma.usuario
    zIndex: '2147483637'
  },
  version: '0.0.0',
  bodyOverflow: '',

  /**
   * Adiciona um novo módulo a aplicação
   * @param {String} name Nome do módulo
   * @param {String} url (opcional) URL do módulo
   */
  add: function add(name, url) {
    var atributo;
    var iframe;
    var iframeContainer = document.getElementById('iframe-container');
    var iframeUrl = url;
    var moduleName;
    var reactModules = [
      'platform.digital-signature',
      'platform.onboarding-modal',
      'platform.notification',
      'platform.sms-modal',
      'platform.standalone',
      'platform.alert-v2-5',
      'platform.patient-management',
      'platform.sdk-v2-5',
      'platform.subscription-manager',
      'platform.prescription-v2-5',
      'platform.prescription-history-v2-5',
      'platform.digital-signature-v2-5'
    ];

    var urlSchema;
    var fullPath;
    var pathBuild;
    

    if (!name) {
      throw new Error('O parametro "name" é obrigatório');
    }

    if (typeof name !== 'string') {
      return;
    }

    moduleName = name.split('?')[0];

    if (this.list[moduleName]) return;

    urlSchema = MdHub.domain.indexOf('local') === 0 ? '//' : 'https://';
    fullPath = MdHub.domain + '/modulos/' + name;
    pathBuild = reactModules.indexOf(moduleName) !== -1 ? '/build/index.html?_=' : '/index.html?_=';

    if (!iframeUrl) {
      iframeUrl = urlSchema + fullPath + pathBuild + Date.now();
    }

    // Cria e define as configurações padrões do iframe do módulo
    iframe = document.createElement('IFRAME');
    iframe.setAttribute('id', 'mdhub-module-' + moduleName);
    iframe.setAttribute('name', moduleName);
    iframe.setAttribute('src', iframeUrl);

    // Aplica os estilos padrões no iframe
    for (atributo in this.styesDefault) {
      if (Object.prototype.hasOwnProperty.call(this.styesDefault, atributo)) {
        iframe.style[atributo] = this.styesDefault[atributo];
      }
    }

    iframeContainer.appendChild(iframe);

    this.list[moduleName] = {
      window: iframe
    };
  },

  /**
   * Verifica se ainda existe módulos sendo apresentados na interface
   * Se a lista de módulos viziveis estiver vazia, aplica as alterações no comportamento da página
   */
  checkListShowing: function checkListShowing() {
    var self = this;
    var modules = this.listShowing;

    /*
      O módulo plataforma.sdk não pode entrar nessa regra pois ele não
      é um módulo visual
    */
    if (modules['plataforma.sdk']) {
      delete modules['plataforma.sdk'];
    }

    // Caso não possua mais nenhum módulo aparecendo
    if (Object.keys(modules).length === 0) {
      // Se não possuir o atributo bodyOverflow, seta o overflow da pagina para 'visible'
      document.body.style.overflow = self.bodyOverflow || 'visible';

      // Se não tiver nenhum módulo sendo mostrado, esconde o container
      document.getElementById('iframe-container').style.display = 'none';
    }
  },

  /**
   * Adiciona as dependências de um módulo
   * @param  {Object} require Lista de módulos requeridos
   */
  getRequire: function getRequire(require) {
    var i;

    if (!require) return;

    for (i = 0; i < require.length; i += 1) {
      MdHub.module.add(require[i]);
    }
  },

  /**
   * Inicializa uma instancia de um módulo
   * @param  {Object} options Opções de inicialização.
   */
  init: function init(module) {
    var moduleData;

    if (!module) {
      throw new Error('O parametro "module" é obrigatório');
    }

    moduleData = MdHub.module.list[module.name];

    // @TODO: tratar melhor essa situação, ocorre quando o modulo é o próprio Hub
    if (!moduleData) {
      throw new Error('O módulo "' + module.name + '" não foi encontrado.');
    }

    moduleData.version = module.version || 1;
    moduleData.build = module.build || 0;
    moduleData.options = module.options;
    moduleData.require = module.require;
    moduleData.window.allowtransparency = 'true';

    // Se possui a opção, cria o módulo em modo CatchAll
    if (moduleData.options && moduleData.options.mode === 'catchAll' && !MdHub.module.listCatchAll[module.name]) {
      MdHub.module.listCatchAll[module.name] = module.name;
    }

    return moduleData;
  },

  /**
   * Mostra um módulo na tela da aplicação
   * @param  {String} name Nome do módulo
   */
  show: function show(name) {
    var self = this;

    if (!name) {
      throw new Error('O parametro "name" é obrigatório');
    }

    // Em modo Client, dispara um comando para o MdHub Server
    if (MdHub.mode === 'client') {
      MdHub.command.send('hub', 'core:moduleShow', name);
      return;
    }

    // Em modo Server, dispara um evento broadcast
    if (!this.list[name]) return;

    MdHub.event.trigger('core:moduleShow', { moduleName: name });

    self.list[name].window.style.display = 'block';
    self.listShowing[name] = name;
    // Armazena o overflow original, assim quando não existir mais módulos sendo
    // mostrados retorna ao inicial
    if (!self.bodyOverflow) {
      self.bodyOverflow = getComputedStyle(document.body).overflow || 'visible';
    }

    if (MdHub.optionsCustom.global.fullscreen) {
      document.body.style.overflow = 'hidden';
    }

    document.getElementById('iframe-container').style.display = 'block';
  },

  /**
   * Esconde um módulo na tela da aplicação
   * @param  {String} name Nome do módulo
   */
  hide: function hide(name) {
    if (!name) {
      throw new Error('O parametro "name" é obrigatório');
    }

    // Em modo Client, dispara um comando para o MdHub Server
    if (MdHub.mode === 'client') {
      MdHub.command.send('hub', 'core:moduleHide', name);
      return;
    }

    // Em modo Server, dispara um evento broadcast
    if (!this.list[name]) return;

    this.list[name].window.style.display = 'none';

    delete this.listShowing[name];

    this.checkListShowing();

    MdHub.event.trigger('core:moduleHide', {
      moduleName: name
    });
  },

  /**
   * Atualiza os estilos de um iframe para determinado módulo
   * @param  {Object} data Objeto com informações do nome do módulo e estilos
   * Exemplo:
   * data = {
   *  moduleName: 'Nome do módulo',
   *  styles: {
   *    zIndex: 1000
   *  }
   * }
   */
  updateStyle: function updateStyle(data) {
    var atributo;

    for (atributo in data.styles) {
      if (Object.prototype.hasOwnProperty.call(data.styles, atributo)) {
        this.list[data.moduleName].window.style[atributo] = data.styles[atributo];
      }
    }
  }
};
